module.exports = __webpack_public_path__ + "static/img/BYD_H5.7cbd68f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/BYD_H5.png
// module id = wa7E
// module chunks = 34